export default {
  config: {
    debugLevel: 0,
    filters: [],
    modules: {
      folders: ['modules/types'],
    },
    header: false,
  },
  possibleViews: {
    Home: {
      url: '',
    },
  },
};
